import axiosHelper from './helpers/axiosHelper';
import OrderStatusModel from './models/OrderStatusModel';

const orderStatusesModule = {
	state() : { orderStatuses: Array<OrderStatusModel>  } {
		return {			
			orderStatuses: []
		}
	},
	actions: {
		async loadOrderStatusesAsync(ctx: any) {
			const storeOrderStatusesMutation = (orderStatuses: Array<OrderStatusModel>) => ctx.commit('storeOrderStatuses', orderStatuses);

			try {
				const refreshTokenHttpClient = axiosHelper.createInstance();
				const response = await refreshTokenHttpClient.get('/api/orderstatuses');
				if (!response?.data?.length) {
					storeOrderStatusesMutation([]);
					return;
				}

				const statuses = response.data.map((r: any) => new OrderStatusModel(r));
				storeOrderStatusesMutation(statuses);
			} catch (e) {
				console.error('Unable to get order-statuses list', e);
			}
		}
	},
	mutations: {
		storeOrderStatuses(state: any, payload: Array<OrderStatusModel>) {
			state.orderStatuses = payload;
		}
	},
	getters: {
		/* list of all existing order-statuses */
		orderStatuses(state: any) : Array<OrderStatusModel> {
			return state.orderStatuses;
		}
	}
};

export default orderStatusesModule;